import { ReloadPage } from './ReloadPage';

export default ReloadPage;


// WEBPACK FOOTER //
// ./src/components/ReloadPage/index.ts